import type { Asset } from "@overmap-ai/common"
import React, { createContext } from "react"

interface ISelectedAssetsContext {
	// The ID of the issue that is active/selected on the map
	selectedAssetIds: Asset["uuid"][]
	setSelectedAssetIds: React.Dispatch<React.SetStateAction<Asset["uuid"][]>>
}

export const SelectedAssetsContext = createContext({} as ISelectedAssetsContext)
